// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"2aecad3c","455":"e021a6ef","488":"1a9a8f8c","614":"ded799d6","685":"729ef1fc","695":"44a1ab15","977":"a3022c91"}[chunkId] + ".chunk.js";
};